import {
	type OrderCallCreateDto,
	postOrdersOrderIdCalls,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const orderMutationsResource = Resources.base.order.mutations;

export const useCreateCallOutcome = (orderId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: OrderCallCreateDto) =>
			postOrdersOrderIdCalls(data, orderId),
		),
		onError: (error) => {
			console.error(
				`${t(orderMutationsResource.orderCallOutcomeError)}:`,
				error,
			);
		},
		onSuccess: () => {
			toast.success(t(orderMutationsResource.orderCallOutcomeSuccess));
			queryClient.invalidateQueries({ queryKey: orderKeys.detail(orderId) });
		},
	});
};
